import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { FaDuotoneIconComponent } from '@fortawesome/angular-fontawesome';
import { faCalendarClock, faClock, faHourglassEnd } from '@fortawesome/pro-duotone-svg-icons';
import { TranslatePipe } from '@ngx-translate/core';

import {
  TooltipDirective,
  TooltipPosition,
} from '../../../shared/components/ui/tooltip/tooltip.directive';
import { MeetingClockService } from '../../services/meeting-clock.service';
import { LocalizedDatePipe } from '../../../shared/pipes/localized-date.pipe';

/**
 * - `pills`    — elapsed · scheduled window · overrun, as small pills
 * - `chip`     — only the most relevant value (narrow spots, mobile)
 * - `progress` — a thin line of the elapsed share of the window
 */
export type MeetingTimeMode = 'pills' | 'chip' | 'progress';

/**
 * Read-only display of the current meeting's timing. The only component that
 * reads the ticking {@link MeetingClockService} signals, so the clock never
 * re-renders anything larger than this leaf.
 */
@Component({
  selector: 'andor-meeting-time',
  standalone: true,
  imports: [
    LocalizedDatePipe,
    NgTemplateOutlet,
    TranslatePipe,
    FaDuotoneIconComponent,
    TooltipDirective,
  ],
  templateUrl: './meeting-time.html',
  styleUrl: './meeting-time.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeetingTime {
  readonly mode = input<MeetingTimeMode>('pills');
  readonly tooltipPosition = input<TooltipPosition>('below');

  protected readonly clock = inject(MeetingClockService);

  protected readonly faClock = faClock;
  protected readonly faCalendarClock = faCalendarClock;
  protected readonly faHourglassEnd = faHourglassEnd;
}
